import React from "react";
import PropTypes from "prop-types";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import "./button-link.scss";

const ButtonLink = ({
  icon,
  iconPosition,
  textButton,
  wrapperStyles,
  className,
  handlerClick,
  disabled,
}) => {
  return (
    <div className={wrapperStyles}>
      <button
        type="button"
        className={`${className || "link-container"} ${disabled && "disabled"}`}
        onClick={handlerClick}
        disabled={disabled}
      >
        {icon && iconPosition === "right" && (
          <span className="link">
            <FontAwesomeIcon icon={icon} />
          </span>
        )}

        <span className="link-description">{textButton}</span>

        {icon && iconPosition === "left" && (
          <span className="link">
            <FontAwesomeIcon icon={icon} />
          </span>
        )}
      </button>
    </div>
  );
};

ButtonLink.defaultProps = {
  icon: "",
  iconPosition: "right",
  textButton: "",
  wrapperStyles: "",
  className: "",
  disabled: false,
};

ButtonLink.propTypes = {
  icon: PropTypes.string,
  iconPosition: PropTypes.oneOf(["right", "left"]),
  textButton: PropTypes.string,
  wrapperStyles: PropTypes.string,
  className: PropTypes.string,
  handlerClick: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
};

export default ButtonLink;
